import { categoryZones } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

interface CategorySectionProps {
  onSelectCategory: (category: string) => void;
}

export default function CategorySection({ onSelectCategory }: CategorySectionProps) {
  return (
    <section id="category" className="py-16 md:py-24 bg-background-100 border-y border-background-200">
      <div className="mx-auto max-w-page px-4 md:px-6">
        <SectionHeading
          eyebrow="Categories"
          title="按兴趣挑选分类专区"
          desc="如果不确定看什么，可以从分类出发。每个专区都汇总了对应类型的主播与回放，点选任意专区会自动筛选上方的回放列表并跳转过去。"
        />

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {categoryZones.map((zone) => (
            <button
              key={zone.id}
              type="button"
              onClick={() => onSelectCategory(zone.name)}
              data-reveal
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 text-left transition-colors hover:border-primary-300 cursor-pointer"
            >
              <div className="relative w-full aspect-square overflow-hidden">
                <img
                  src={zone.cover}
                  alt={`${zone.name}分类专区封面`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <span className="absolute inset-0 bg-gradient-to-t from-black/55 to-transparent" />
                <span className="absolute left-3 top-3 w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/90 text-primary-600 text-lg">
                  <i className={zone.icon} />
                </span>
                <span className="absolute bottom-3 left-3 text-base font-semibold text-white">
                  {zone.name}
                </span>
              </div>
              <div className="p-3">
                <p className="font-num text-sm font-bold text-primary-600">
                  {zone.count}
                  <span className="ml-1 text-[11px] font-normal text-foreground-500">位主播</span>
                </p>
                <p className="mt-1 text-[11px] leading-relaxed text-foreground-600 line-clamp-2">
                  {zone.desc}
                </p>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}